import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { YoyakuMasterService } from '../service/ymaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Role } from '../app.constant';
import { UsersService } from '../service/users.service';

@Component({
    selector: 'ytimeaxis-list-app',
    templateUrl: './ytimeaxis-list.component.html',
    styleUrls: ['ytimeaxis-list.component.css']
})
export class YTimeaxisListComponent implements OnInit {
    title : string = '時間軸リスト';
    isLoaded : boolean = false;
    selected: boolean = false;
    datalist: any = [];
    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 5;   /* 最大表示件数 */
    selected_event_id : number = null;
    search_flg = 0;
    page_flg = 0;
     ROLE: any = Role;

    constructor(
        private commonService: CommonService,
        private yoyakumasterService: YoyakuMasterService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        public usersService: UsersService,
    ) { }

    select_data:any={
        'name_name':'タイトル',
        'name_description':'説明文',
        'name_support':'2文字以上、10文字以内で入力してください。',
        'description_support':'説明文を入力してください',
        'data' : {},
        
    };

    ngOnInit(): void {
        this.getList();
        //Loading停止　→　仮で入れています。getList処理を作る時に消してください
        // this.commonService.loadingEnd();

    };

    clearData(): void {
        this.isLoaded = false;
        this.selected = false;
        this.datalist = [];
    }

    getList(): void {
        this.clearData();
        let param ={
            page : this.page,
            display_per_page:this.display_per_page
        };
        this.yoyakumasterService.getTimeaxisList(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.datalist= res["fuel_results"]['timeaxis_list'];
                this.all_count = res["fuel_results"]["all_count"];
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    checkData(name:string){
        switch (name) {
            // 全角文字
            case "zenkaku":
                return (name.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) ? 1 : 2;
            // 全角ひらがな
            case "hiragana":
                return (name.match(/^[\u3041-\u3096]+$/)) ? 1 : 2;
            // 全角カタカナ
            case "katakana":
                return (name.match(/^[\u30a1-\u30f6]+$/)) ? 1 : 2;
            // 半角英数字（大文字・小文字）
            case "alphanumeric":
                return (name.match(/^[0-9a-zA-Z]+$/)) ? 2 : 1;
            // 半角数字
            case "numeric":
                return (name.match(/^[0-9]+$/)) ? 2 : 1;
            // 半角英字（大文字・小文字）
            case "alphabetic":
                return (name.match(/^[a-zA-Z]+$/)) ? 2 : 1;
        }
        return 1;
    }
    
    save():void{this.commonService.modalOpens(50001,
        //保存してもよろしいですか？
        modalresult => {
            if (modalresult == "OK"){
                this.yoyakumasterService.saveTimeaxisList(this.select_data.data)
                .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            this.commonService.modalOpens(10001,modalresult=>{
                                if (modalresult == "OK"){
                                    this.editSelectRowData(undefined);
                                    this.selected = false;
                                    this.getList();
                                }
                            });
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    },error => {
                        this.commonService.modalOpens(error,modalresult=>{});
                    });                
            }else{
            }
        }
    );
    }
    update():void{this.commonService.modalOpens(50001,
        //保存してもよろしいですか？
        modalresult => {
            if (modalresult == "OK"){
                this.yoyakumasterService.updateTimeaxisList(this.select_data.data)
                .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            this.commonService.modalOpens(10001,modalresult=>{
                                if (modalresult == "OK"){
                                    this.editSelectRowData(undefined);
                                    this.selected = false;
                                    this.getList();
                                }
                            });
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    },error => {
                        this.commonService.modalOpens(error,modalresult=>{});
                    });  
                
            }else{
            }
        }
    );
    }
    cancel():void{
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
                 modalresult => {
                    if (modalresult == "OK"){
                        this.selected = false;
                    }else{
                    }
                }
            );
    }
    delete():void{
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.yoyakumasterService.deleteTimeaxisList(this.select_data.data)
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002,modalresult=>{
                                    this.selected = false;
                                    this.getList();
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });  
                    }else{

                }
            }
        );
    }

    // 編集
    edit(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.editSelectRowData(row);
                        //画面上部へ移動
                        window.scrollTo(0, 0);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }
    editSelectRowData(row: any): void {

        if (row == undefined){
            this.selected = true;
            this.select_data.data = { 
                id: null,
                t_id:null,
                t_name: null,
                t_short: null,
                sort: null
            };
        }else{
            this.selected = true;
            this.select_data.data = JSON.parse(JSON.stringify(row))
        }
    }
    upRow(row:number,data:any) : void{
        let tempdatalist;
            tempdatalist = this.datalist;
        
        if (row==0){//最初

        }else{
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            //１つ前のレコード beforeRecord
            let beforeRecord = tempdatalist[row-1];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            beforeRecord['chk_sort'] = beforeRecord['sort'];

            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = beforeRecord['sort'];
            beforeRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,beforeRecord
            this.yoyakumasterService.changeOrderTimeaxisList([myRecord,beforeRecord])
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    tempdatalist.splice(row-1, 2, tempdatalist[row], tempdatalist[row-1]);
                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            },error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });  
        }
    }
    downRow(row:number,data:any) : void{
        let tempdatalist;
            tempdatalist = this.datalist;

        if (row==tempdatalist.length -1){//最終

        }else{
            //１つ後ろのレコード afterRecord
            let afterRecord = tempdatalist[row+1];
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            afterRecord['chk_sort'] = afterRecord['sort'];
            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = afterRecord['sort'];
            afterRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,afterRecord
            this.yoyakumasterService.changeOrderTimeaxisList([myRecord,afterRecord])
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    tempdatalist.splice(row, 2, tempdatalist[row+1], tempdatalist[row]);
                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            },error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });  
        }
    }
    check(){
        if(this.selected==true){
            return true
        }else{
            return false
        }
    }
    checkList(name:string,short:string):boolean{
        if(name==null || name=="" || short==null || short==""){
            return true;
        }
        return false;
    }
    Gotimeaxis(tid:number): void{
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                   
                    this.router.navigate(["/y/timeaxis/" + tid ]);
                }else{
                    return;
                }
           }
        );
    }else{
        this.router.navigate(["/y/timeaxis/" + tid ]);
    }
    
}
    goBack(): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                            this.location.back();
                    }
                }
            );
        }else{
                this.location.back();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/a2121-ytimeaxis-list/ytimeaxis-list.component.ts